import React from 'react';
import Dropdown from 'components/vistaprintUILibrary/Dropdown';
import { getLocalizedText } from '@vp-dst/localization-util';

class DropdownMultiProductSelector extends React.Component {
    constructor(props) {
        super(props);

        this.selectedProductOnChange = this.selectedProductOnChange.bind(this);
        this.addNewRow = this.addNewRow.bind(this);
        this.subtractRow = this.subtractRow.bind(this);
    }

    selectedProductOnChange(event, rowId) {

        let newMultiselectedProducts = [...this.props.multiselectedProducts];
        newMultiselectedProducts[rowId] = event.target.value;

        this.props.setMultiselectedProducts(newMultiselectedProducts);
    }

    addNewRow()
    {
        let largerArray =  [...this.props.multiselectedProducts];
        largerArray.push("noSelection");
        
        this.props.setMultiselectedProducts(largerArray);
    }

    subtractRow(rowId)
    {
        let newArray =  [...this.props.multiselectedProducts];
        newArray.splice(rowId, 1);

        this.props.setMultiselectedProducts(newArray);
    }

    render() {
        const {
            productGroups,
            error,
            multiselectedProducts,
            isReadOnly
        } = this.props;
        return this.createDropdowns(isReadOnly, error, productGroups, multiselectedProducts);
    }

    createDropdowns(isReadOnly, error, productGroups, multiselectedProducts)
    {
        const defaultValue = "noSelection";
        let dropdowns = [];
        for(let i=0; i < multiselectedProducts.length; i++)
        {
            dropdowns.push(
            <div style={{textAlign: "center", margin: "8px 0"}}>
                <Dropdown
                    value={multiselectedProducts[i]}
                    onChange={(e) => this.selectedProductOnChange(e, i)}
                    disabled={isReadOnly}
                    errorMessage={(error && multiselectedProducts[i] === defaultValue) ? '' : null} // pass an empty string as the error message so that the dropdown is highlighted, but there's no text
                    style={{minWidth: "350px"}} //Because the dropdown's width is controlled by the length of its options, we need to supply a large min-width, so removing the longest option from the dropdown (because it was selected in a different dropdown) doesn't change the dropdown's width
                >
                    <option value={defaultValue} defaultValue>{getLocalizedText('select-a-product')}</option>
                    
                    {productGroups.map((productGroup) => {
                        return (
                            <optgroup key={`product-opt-group-${productGroup.name.split(' ').join('')}`} label={getLocalizedText(productGroup.name)}>
                                {productGroup.products.map((product) => {
                                    return (
                                        <option
                                            key={`product-option-${productGroup.name.split(' ').join('')}-${product.name.split(' ').join('')}`}
                                            value={product.value}
                                        >
                                            {getLocalizedText(product.name)}
                                        </option>
                                    );
                                })}
                            </optgroup>
                        );
                    })
                }
                </Dropdown>

                { !isReadOnly &&
                    <div style={{width: 60, display:"inline-block", textAlign:"left"}}>
                        {(multiselectedProducts.length !== 1) &&
                            <button onClick={() => this.subtractRow(i)} class="textbutton textbutton-skin-secondary  textbutton-round" style={{margin:"5px 0 5px 5px"}}>
                                <span class="textbutton-icon textbutton-icon-delete"></span>
                            </button>
                        }
                        {(i === multiselectedProducts.length - 1 && multiselectedProducts.length < 3) &&
                            <button onClick={() => this.addNewRow()} class="textbutton textbutton-skin-primary  textbutton-round" style={{margin:"5px 0 5px 5px"}}>
                                <span class="textbutton-icon textbutton-icon-delete" style={{display:"inline-block", transform:"rotate(45deg)"}}></span>
                            </button>
                        }
                    </div>
                }
                
            </div>
            )
        }

        return dropdowns;
    }
}

export default DropdownMultiProductSelector;


// WEBPACK FOOTER //
// ./src/components/DropdownMultiProductSelector.js